/**
 * util for components
 */

import React from 'react';
import { toLower } from 'lodash';

import { dateTimeFormat } from '../../util/GlobalConstant';

import moment from 'moment';

export const getReadableName = (name) => {
  switch (toLower(name)) {
    case 'level_1':
    case 'level1':
    case 'l1':
      return 'L1';
    case 'currentsystem':
      return 'Current System';
    case 'alertsreported':
      return 'Alerts Reported';
    case 'anomaliesreported':
      return 'Anomalies Reported';
    case 'tookitaki':
      return 'Tookitaki';
    case 'daily_alerts_closed':
      return 'Daily Alerts Closed';
    case 'rulebased':
    case 'rule_based':
      return 'Rule Based';
    case 'noissue':
      return 'No Issue';
    case 'alerts_disposed':
      return 'Alerts Disposed';
    case 'anomalies':
      return 'Anomalies';
    case 'alerts':
      return 'Alerts';
    case 'nsalerts':
      return 'Alerts';
    case 'hits':
      return 'Hits';
    case 'autoclosed':
      return 'L1';
    case 'undetermined':
      return 'Undetermined Hits';
    case 'truehits':
      return 'True Hits';
    case 'falsehits':
      return 'False Hits';
    case 'peer_avg':
      return 'Peer Average';
    case 'throughput':
      return 'Throughput';
    default:
      return name;
  }
};

export const getKeyFromName = (name) => {
  switch (name) {
    case 'Alerts Reported':
      return 'alertsReported';
    case 'Anomalies Reported':
      return 'anomaliesReported';
    case 'Tookitaki':
      return 'tookitaki';
    case 'Rule Based':
      return 'ruleBased';
    case 'Alerts':
      return 'alerts';
    case 'No Issue':
      return 'noIssue';
    case 'l1':
      return 'level1';
    case 'L1':
      return 'level1';
    case 'L1':
      return 'l1';
    case 'L1':
      return 'autoclosed';
    case 'Alerts Disposed':
      return 'alerts_disposed';
    case 'Anomalies':
      return 'anomalies';
    case 'True Hits':
      return 'trueHits';
    case 'False Hits':
      return 'falseHits';
    case 'Hits Yield':
      return 'hitsYield';
    case 'Alerts ':
      return 'nsAlerts';
    case 'Hits':
      return 'hits';
    case 'Current System':
      return 'currentSystem';
    case 'Undetermined':
    case 'Undetermined Hits':
      return 'undetermined';
    default:
      return name;
  }
};

export const CustomizedAxisTick = (props) => {
  const { x, y, stroke, payload } = props;

  const assumingValueIsDate = moment(payload.value);
  const ifDate = assumingValueIsDate.isValid();

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={12}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)">
        {ifDate
          ? moment
              .utc(payload.value, [dateTimeFormat])
              .local()
              .format('DD/MM/YYYY')
          : String(payload.value).replace('00:00:00', '')}
      </text>
    </g>
  );
};
